export default "__VITE_ASSET__DT5A5C1Q__"